// extracted by mini-css-extract-plugin
export default {"container":"template-ready_container__Qizb5","greenButton":"template-ready_greenButton__shCCY"};